export default __webpack_public_path__ + "static/media/comparison-phone.08d2cfe7.png";